var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-screen-dialog',{attrs:{"parameter":"passVorschau","value":"true"}},[_c('toolbar',{attrs:{"title":"Pässe drucken","show-back":true}}),_c('paesse-drucken-vorschau-inhalt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }